import { apis, serviceInterface } from "./config";

export const getDictionary = params => {
  return serviceInterface.get(apis.DICTIONARY, {
    params,
  });
};

export const getTechnicalReferenceContacts = () => {
  return serviceInterface.get("user/technicalReferenceContacts");
};

export const getAllDictionaries = (params = {}) => {
  params["no_graphic"] = true;
  return serviceInterface.get(apis.DICTIONARY, {
    params,
  });
};

export const getDictionaryByNameAndType = (name, type) => {
  return serviceInterface.get(apis.DICTIONARY, {
    params: { name, type },
  });
};

export const createDictionary = body => {
  return serviceInterface.post(apis.DICTIONARY, body);
};

export const updateDictionary = body => {
  return serviceInterface.put(
    `${apis.DICTIONARY}/${body.type}/${encodeURIComponent(body.name)}`,
    body
  );
};
